import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getMenusItems } from '../services/apiservice';
import { ITEMS_IMAGE_BASEURL } from '../constants';
import { printCurrencySymbol } from '../helpers/_commonHelper';
import { useHotel } from '../context/HotelContext';
import { Empty, Switch } from 'antd';
import ContentLoader from 'react-content-loader';
import Header from '../components/Header';
import { useLanguage } from '../context/LanguageContext';

const COCONUT = require('../assets/icons/coconut.png');
const EGG = require('../assets/icons/egg.png');
const GLUTEN = require('../assets/icons/gluten.png');
const MILK = require('../assets/icons/milk.png');
const NUTS = require('../assets/icons/nuts.png');
const SOYA = require('../assets/icons/soya.png');
const TREENUTS = require('../assets/icons/treenuts.png');
const SHELFISH = require('../assets/icons/shellfish.png');
const VEGAN = require('../assets/icons/vegan.png');
const VEGETARIAN = require('../assets/icons/vegetarian.png');

const SignatureDish = require('../assets/icons/Signature-Dish.png');
const Spicy = require('../assets/icons/Spicy.png');
const ContainsFish = require('../assets/icons/Contains-Fish.png');
const Organic = require('../assets/icons/Organic.png');
const ContainsPork = require('../assets/icons/Contains-Pork.png');

const imgList = {
    coconut: COCONUT,
    egg: EGG,
    gluten: GLUTEN,
    milk: MILK,
    nuts: NUTS,
    soya: SOYA,
    treenuts: TREENUTS,
    shellfish: SHELFISH,
    vegetarian: VEGETARIAN,
    vegan: VEGAN,
    signaturedish: SignatureDish,
    spicy: Spicy,
    containsfish: ContainsFish,
    organic: Organic,
    containspork: ContainsPork,
};

const ItemsListing = () => {
    const [itemsList, setItemsList] = useState([]);
    const [searchParams] = useSearchParams();
    const categoryid = searchParams.get('categoryid');
    const template = searchParams.get('template_id') || 3;
    const { hotelDetails } = useHotel();
    const currentCurrency = printCurrencySymbol(hotelDetails);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [loading, setLoading] = useState(false);

    const [hasNonVegItem, setHasNonVegItem] = useState(false);
    const [nonVegToggle, setNonVegToggle] = useState(false);

    const { t } = useLanguage();

    useEffect(() => {
        window.scrollTo(0, 0);

        if (categoryid) {
            fetchMenuItems(categoryid);
        }
    }, [categoryid]);

    const fetchMenuItems = async (categoryid) => {
        try {
            setLoading(true);
            const response = await getMenusItems(categoryid);
            if (response.status === 200) {
                let items = response.data.data || [];
                items = items.filter((item) => {
                    isItemNonVeg(item);
                    return Boolean(item.enabled);
                });
                setItemsList(items);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    // const templateChangeHandler = (value) => {
    //     setTemplate(value);
    // };
    function isItemNonVeg(item) {
        // If any one of the item is non veg then no need check whether item has non-veg category
        if (hasNonVegItem) {
            return;
        }
        if (item.type == 'non_veg') {
            setHasNonVegItem(true);
            return;
        }
    }

    const handleCategoryClick = (id) => {
        setSelectedIndex(id);
        const node = document.getElementById(`category-${id}`);
        var headerOffset = 170;
        var elementPosition = node.getBoundingClientRect().top;
        var offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });

        // const nodeHorizontalCategory = document.getElementById(`top-scroll-${id}`);
        // nodeHorizontalCategory.scrollIntoView();
    };
    return (
        <>
            <Header showBack />
            <div className=' flex flex-col justify-start w-full min-h-screen relative bg-gray-900 gap-4 px-4 pt-4 pb-10'>
                {hasNonVegItem && (
                    <div className='filter-veg flex gap-2'>
                        <label className='text-white'>
                            {t['ird_vegetarian_only']}
                        </label>
                        <Switch
                            checked={nonVegToggle}
                            className='text-green-600'
                            onChange={() =>
                                setNonVegToggle((nonVegToggle) => !nonVegToggle)
                            }
                        />
                    </div>
                )}
                {/* <div
                className='py-2 flex flex-row justify-start px-2 overflow-x-auto  shadow-sm '
                style={{
                    scrollbarWidth: 'none',
                }}
            >
                <div className='flex flex-row justify-center text-xs gap-8'>
                    {itemsList.map((category) => {
                        return (
                            <div
                                className={
                                    'flex flex-col w-32 justify-center items-center gap-6 cursor-pointer ' +
                                    (selectedIndex === category.id
                                        ? 'selected'
                                        : '')
                                }
                                key={category.id}
                                onClick={() => handleCategoryClick(category.id)}
                                id={`top-scroll-${category.id}`}
                            >
                                <img
                                    src={
                                        category.image
                                            ? `${CATEGORY_IMAGE_BASEURL}${encodeURIComponent(
                                                  category.image
                                              )}`
                                            : ''
                                    }
                                    alt={category.name}
                                    className='w-32 h-32 rounded-full object-cover object-center'
                                />
                                {selectedIndex === category.id ? (
                                    <Badge
                                        className='badge text-sm text-white text-center'
                                        count={category.name}
                                        style={{ backgroundColor: '#52c41a' }}
                                    ></Badge>
                                ) : (
                                    <div className='text-sm text-white text-center'>
                                        {category.name}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div> */}
                {/* <div className='flex justify-start'>
                    <Select
                        onChange={templateChangeHandler}
                        style={{ minWidth: '10rem', color: '#000' }}
                        value={template}
                    >
                        <Select.Option value='1'>Template 1</Select.Option>
                        <Select.Option value='2'>Template 2</Select.Option>
                        <Select.Option value='3'>Template 3</Select.Option>
                        <Select.Option value='4'>Template 4</Select.Option>
                    </Select>
                </div>  */}
                <div className='flex flex-col w-full'>
                    {loading ? (
                        <LoadingSkelton />
                    ) : itemsList.length === 0 ? (
                        <Empty />
                    ) : (
                        <div
                            className={
                                'flex flex-col w-full gap-8 ' +
                                (template == 4 ? ' temp4-root flex-row' : '')
                            }
                        >
                            {itemsList
                                .filter(
                                    (item) =>
                                        !(
                                            nonVegToggle &&
                                            item.type == 'non_veg'
                                        )
                                )
                                .map((item) => {
                                    return (
                                        <div
                                            className={
                                                'flex flex-row gap-6 ' +
                                                (template == 2
                                                    ? ' even:flex-row-reverse temp2'
                                                    : '') +
                                                (template == 3
                                                    ? ' flex-col temp3'
                                                    : '') +
                                                (template == 4
                                                    ? ' flex-col temp4'
                                                    : '')
                                            }
                                            key={item.id}
                                        >
                                            <div className='flex flex-1 relative'>
                                                <img
                                                    src={
                                                        item.thumbnail
                                                            ? `${ITEMS_IMAGE_BASEURL}${encodeURI(
                                                                  item.thumbnail
                                                              )}`
                                                            : `${process.env.REACT_APP_AWS_ASSETS_ROOT_URL || 'https://stvserveproduction.blob.core.windows.net/media/'}menu-categories/Maincourse.jpg`
                                                    }
                                                    alt={item.name}
                                                    className={
                                                        'w-full h-96 object-cover '
                                                    }
                                                />
                                                {(item.type == 'veg' ||
                                                    item.type == 'non_veg') && (
                                                    <div
                                                        className={
                                                            'icon-img ' +
                                                            (item.type ==
                                                            'non_veg'
                                                                ? 'non-veg'
                                                                : 'veg')
                                                        }
                                                    ></div>
                                                )}
                                            </div>
                                            <div
                                                className={
                                                    'flex flex-1  py-2 gap-2 flex-col content '
                                                }
                                            >
                                                <div
                                                    className={
                                                        'flex gap-2 flex-col justify-start content-wrapper '
                                                    }
                                                >
                                                    <div
                                                        className={
                                                            'flex flex-col '
                                                        }
                                                    >
                                                        <div className='text-white text-2xl'>
                                                            {item.name}
                                                        </div>
                                                        {item.description && (
                                                            <div
                                                                className='text-gray-300 text-xl font-medium whitespace-pre-wrap'
                                                                dangerouslySetInnerHTML={{
                                                                    __html: item.description,
                                                                }}
                                                            ></div>
                                                        )}
                                                        {JSON.parse(item.tags)
                                                            ?.length > 0 && (
                                                            <div className='flex flex-row flex-wrap gap-1 mt-3'>
                                                                <RenderAllergens
                                                                    allergens={JSON.parse(
                                                                        item.tags
                                                                    )}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                {item.price > 0 && (
                                                    <div className='text-white text-xl font-semibold whitespace-nowrap'>
                                                        {currentCurrency}{' '}
                                                        {item.price.toLocaleString(
                                                            'en-US',
                                                            {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2,
                                                            }
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    )}
                </div>
                <div className='flex flex-col   w-full px-4 text-center justify-center items-center mt-4'>
                    <div
                        className='flex flex-col font-normal text-xs text-gray-300'
                        dangerouslySetInnerHTML={{
                            __html: t['restaurant_disclaimer_msg_one'],
                        }}
                    ></div>
                </div>
            </div>
        </>
    );
};

export default ItemsListing;

const RenderAllergens = ({ allergens = [] }) => {
    return allergens.map((tag) => (
        <div className={`text-black rounded-lg mr-1 ${tag} `} key={tag}>
            <img
                style={{
                    width: 40,
                    height: 40,
                    objectFit: 'contain',
                }}
                alt='alergens'
                src={imgList[String(tag).toLowerCase()]}
            />
        </div>
    ));
};

const LoadingSkelton = (props) => {
    return (
        <ContentLoader
            viewBox='0 0 400 200'
            width={'100%'}
            height={'100%'}
            title='Loading news...'
            {...props}
        >
            <rect
                x='42.84'
                y='9.93'
                rx='5'
                ry='5'
                width='143.55'
                height='86.59'
            />
            <rect
                x='192.84'
                y='9.67'
                rx='0'
                ry='0'
                width='148.72'
                height='12.12'
            />
            <rect x='192.84' y='25.67' rx='0' ry='0' width='89' height='9' />

            <rect
                x='42.84'
                y='107'
                rx='5'
                ry='5'
                width='143.55'
                height='86.59'
            />
            <rect
                x='192.84'
                y='107'
                rx='0'
                ry='0'
                width='148.72'
                height='12.12'
            />
            <rect x='192.84' y='123' rx='0' ry='0' width='89' height='9' />
        </ContentLoader>
    );
};
